/**
 * @author Trendrating <info@trendrating.net>
 *
 * @module api/account/Preferences
 * @summary Requests for account preferences
 *
 */

import { deepClone } from "../../deepClone";
import { StoredObjectType } from "../../types/Api";
import { _StoredObjects } from "../_StoredObjects";
import { defaultPreferences } from "./defaultPreferences";

export class Preferences extends _StoredObjects {
    NAME = "__GLOBAL_ACCOUNT_PREFERENCES__";
    VERSION = "2.0";

    storedObjectType = "PREFERENCE_GENERIC" as const;

    clone(target: any, source: any) {
        const clonedSource = deepClone(source);
        const clonedTarget = deepClone(target);
        for (const key in clonedSource) {
            clonedTarget[key] = clonedSource[key];
        }
        return clonedTarget;
    }

    /**
     * Decode server params in UI params
     */
    decode(object: any, type?: StoredObjectType) {
        let decoded = deepClone(object);

        decoded["name"] =
            type === "ALERTS_NEWS_FILTER"
                ? "__ALERTS_NEWS_ACCOUNT_FILTERS__"
                : this.NAME;
        decoded["version"] = this.VERSION;

        return decoded;
    }

    /**
     * Encode UI params in server params
     */
    encode(object: any, type: StoredObjectType | null, accountPreferences, accountNewsFilters) {
        var encoded = deepClone(object);
        // var accountNewsFilters =
        //     this.environment.account.user?.alertsNewsFilters;

        if (type !== "ALERTS_NEWS_FILTER") {
            encoded["id"] =
                accountPreferences != null ? accountPreferences.id : null;
        } else {
            encoded["id"] =
                accountNewsFilters != null ? accountNewsFilters.id : null;
        }

        encoded["name"] =
            type === "ALERTS_NEWS_FILTER"
                ? "__ALERTS_NEWS_ACCOUNT_FILTERS__"
                : this.NAME;
        encoded["version"] = this.VERSION;

        if (encoded["preferences"] != null) {
            var preferences = encoded["preferences"];
            // #region ----------------------- migrate report 2017-09-18 - START
            if ("report" in preferences) {
                if (preferences["report"] == null) {
                    encoded["preferences"]["report"] = {
                        general: {
                            disclaimer: null,
                            logo: null,
                            theme: null,
                        },
                    };
                } else if (!("general" in preferences["report"])) {
                    encoded["preferences"]["report"] = {
                        general: {
                            disclaimer: null,
                            logo: {
                                base64: preferences["report"]["logo"]["base64"],
                                url: null,
                            },
                            theme: null,
                        },
                    };
                } else {
                    encoded["preferences"]["report"] = {
                        general: this.clone(
                            {
                                disclaimer: null,
                                logo: null,
                                theme: null,
                            },
                            preferences["report"]["general"]
                        ),
                    };
                }
            } else {
                encoded["preferences"]["report"] = null;
            }
        }

        // #endregion ---------------------- migrate report 2017-09-18 - END

        return encoded;
    }

    async get(user_id?:number,type?: StoredObjectType) {
        const response = await super.get(null, type, user_id);

        if (response.length === 0) {
            return this.decode({
                preferences: defaultPreferences,
            });
        }

        return this.decode(response[0], type);
    }

    /**
     * User's tracked strategies
     *
     * @returns {array|null}
     */
    // getTrackedStrategies() {
    //     var account = this.environment.account;
    //     var preferences = account.user?.preferences?.preferences;

    //     if (preferences?.indexes && preferences.indexes.length > 0) {
    //         return preferences.indexes.map((item: string) =>
    //             parseInt(item, 10)
    //         );
    //     }

    //     return null;
    // }

    /**
     * Saves user preferences
     *
     * @param {object} params - request parameters
     * @param {object} params.preferences - user peferences
     * @param {number} params.id - if specified it means that the template
     *       already exits and has been modified. Otherwise a new template
     *       will be crated
     * @param {string} params.name - name of the template
     *
     * @returns {Promise} a promise fulfilled with the
     *       handled data of the response
     */
    // async save(object: any, objectType?: StoredObjectType | null) {
    //     const type = objectType ?? null;
    //     var encoded = this.encode(object, type);

    //     let response;
    //     if (encoded["id"] == null) {
    //         response = await this.create(encoded, type);
    //     } else {
    //         response = await this.update(encoded, type);
    //     }

    //     return this.decode(response);
    // }

    /**
     *
     * @param {string} key
     * @param {any} value
     */
    // async setPreferenceKey(key: string, value: any) {
    //     var account = this.environment.account;

    //     if (
    //         account == null ||
    //         account.user == null ||
    //         account.user.preferences == null
    //     ) {
    //         return null;
    //     }

    //     const preferencesToUpdate = deepClone(account.user.preferences);
    //     if (preferencesToUpdate.preferences == null) {
    //         return null;
    //     }
    //     preferencesToUpdate.preferences[key] = value;

    //     const preferencesUpdated = await this.save(preferencesToUpdate);

    //     account.user.preferences = preferencesUpdated;

    //     return preferencesUpdated;
    // }
}
